import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue/client'

import App from './App.vue'

import router from './router/Index.js'
import i18n from './locales'
import api from '@/services/axios'
import { initTheme } from '@/utils/theme'

import { useSeoStore } from '@/stores/seo'

import './assets/styles/main.scss'
import 'vue-toastification/dist/index.css'

import Toast, { POSITION } from 'vue-toastification'

window.addEventListener('error', (event) => {
  if (
    event.message &&
    event.message.includes('ResizeObserver loop')
  ) {
    event.stopImmediatePropagation()
  }
})

const toastOptions = {
  position: POSITION.BOTTOM_RIGHT,
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  hideProgressBar: false
}

const SUPPORTED_LANGUAGES = ['id', 'en']

function getStoredLanguage() {
  try {
    const stored = localStorage.getItem('language')
    return SUPPORTED_LANGUAGES.includes(stored) ? stored : null
  } catch {
    return null
  }
}

function saveLanguage(language) {
  try {
    localStorage.setItem('language', language)
  } catch {
    // ignore
  }
}

async function resolveLanguage() {
  // 1. Prioritas: pilihan user tersimpan (localStorage)
  const stored = getStoredLanguage()
  if (stored) return stored

  // 2. Fallback: default dari backend
  try {
    const response = await api.get('/public/platform-preferences')
    const preferences = response.data?.data || {}

    const backendDefault = preferences.default_language
    if (SUPPORTED_LANGUAGES.includes(backendDefault)) {
      return backendDefault
    }
  } catch (error) {
    console.error(
      'Gagal memuat bahasa default platform:',
      error
    )
  }

  // 3. Fallback terakhir
  return 'id'
}

async function bootstrap() {
  // ===== Bahasa =====
  try {
    const language = await resolveLanguage()
    i18n.global.locale = language
    saveLanguage(language)
  } catch (error) {
    console.error('Gagal menginisialisasi bahasa:', error)
    i18n.global.locale = 'id'
  }

  // ===== Tema =====
  try {
    await initTheme()
  } catch (error) {
    console.error('Gagal menginisialisasi tema:', error)
  }

  // ===== App =====
  const app = createApp(App)
  const pinia = createPinia()
  const head = createHead()

  app.use(pinia)
  app.use(router)
  app.use(i18n)
  app.use(head)
  app.use(Toast, toastOptions)

  // ===== SEO =====
  try {
    await useSeoStore(pinia).load()
  } catch (error) {
    console.error('Gagal memuat SEO default:', error)
  }

  app.mount('#app')
}

bootstrap()